import { useMutation } from "react-query";
import { client } from "../client";
import { SupplyOrder } from "../types/supplies.types";

export const createSupplyOrder = async ({
	centerId,
	order,
}: {
	centerId: number;
	order: SupplyOrder[];
}) => {
	const response = await client.post("/supplies/order", {
		centerId,
		order,
	});
	return response.data;
};

export const useChangeSupplyOrder = ({
	onSuccess,
}: {
	onSuccess?: () => void;
}) => {
	return useMutation({
		mutationFn: async ({ prev, next }: { prev: number; next: number }) => {
			const response = await client.patch("/supplies/", {
				prev,
				next,
			});
			return response.data;
		},
		onSuccess,
	});
};
